module.exports = __webpack_public_path__ + "img/cz.5a505c0f.svg";